import { Action } from 'redux'
import { IProfile } from '../../../models/Object'
import { UserProfileActions as ObjectActions } from '../../../reducers/userObject/actionNames'

const requestDataForObject = (): IRequestDataForObject => ({
  type: ObjectActions.RequestDataForUserProfile,
})

export interface IRequestDataForObject
  extends Action<ObjectActions.RequestDataForUserProfile> {
  type: ObjectActions.RequestDataForUserProfile
}

export default requestDataForObject

export const dataForObjectIsAccepted = (
  data: IProfile,
): IDataForObjectIsAccepted => ({
  profile: data,
  type: ObjectActions.DataForUserProfileAccepted,
})

export interface IDataForObjectIsAccepted
  extends Action<ObjectActions.DataForUserProfileAccepted> {
  profile: IProfile
}

export const dataForObjectIsRejected = (
  errMessage: string,
): IDataForObjectIsRejected => ({
  errMessage,
  type: ObjectActions.DataForUserProfileRejected,
})

export interface IDataForObjectIsRejected
  extends Action<ObjectActions.DataForUserProfileRejected> {
  errMessage: string
}
